import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import ResponsiveSourceImage from "../../atoms/responsive-source-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-3.m.css";

const CardImageType3 = ({ story, headlineLimit, desktopWidths = [250, 480, 640], mobileWidths = [250, 480, 640] }) => {
  const storyObj = story.story ? story.story : story;
  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${storyObj.slug}`} className="wrapper-card-image-type-3">
      <div styleName="wrapper" className="card-image-type-3">
        {storyImageSlug ? (
          <ResponsiveSourceImage
            story={storyObj}
            desktopAspectRation={[267, 332]}
            mobileAspectRation={[16, 9]}
            desktopWidths={desktopWidths}
            mobileWidths={mobileWidths}
          />
        ) : (
          <PlaceholderImage story={storyObj} />
        )}
        <div styleName="headline">
          <Headline story={storyObj} headerType={5} headerLevel={3} headlineLimit={headlineLimit} />
        </div>
      </div>
    </Link>
  );
};

export default CardImageType3;

CardImageType3.propTypes = {
  story: object,
  headlineLimit: number,
  desktopWidths: array,
  mobileWidths: array
};
